import { WitaConnector } from '@/services/repository/connector'

import { GetTarefasParams, GetTarefasResponse } from '../domain/tarefa'

const ROOT_URL = '/administrative'

export const TarefaService = {
  getTarefas: async ({ userId }: GetTarefasParams) => {
    const url = ROOT_URL + `/list/${userId}`
    return await WitaConnector.get<GetTarefasResponse>(url)
  },
}
